import { Spinner } from "@chakra-ui/react";
import { UI } from "components";
import { resetChatwootWidget } from "hooks/useChatwoot";
import { useEffect } from "react";

export default function Logout(){

    const handleLogout = async () => {
        try{
            // Reseta o widget antes de limpar o localStorage para evitar estado inconsistente
            resetChatwootWidget()
            localStorage.removeItem('@token')
            localStorage.clear()
        }catch(err){}

        setTimeout(() => { window.location.reload() }, 2000)
    }

    useEffect(() => {
        handleLogout()
    }, [])

    return(
    <>
        <UI.Header title="Logout" />

        <UI.Alert indicator={<Spinner />}>Saindo da sua conta...</UI.Alert>
    </>
    )
}